export const formatDate = (date) => {
    if (!date) return '-';
    
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    
    return d.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

export const formatDateTime = (date) => {
    if (!date) return '-';
    
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    
    return d.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const formatCurrency = (amount, currency = 'RUB') => {
    if (amount === null || amount === undefined) return '-';
    
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: currency
    }).format(amount);
};

export const formatNumber = (num, decimals = 2) => {
    if (num === null || num === undefined) return '-';
    
    return new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(num);
};

export const formatPercent = (value) => {
    if (value === null || value === undefined) return '-';
    
    return new Intl.NumberFormat('ru-RU', {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    }).format(value / 100);
};

export const formatBoolean = (value) => {
    if (value === null || value === undefined) return '-';
    return value ? 'Да' : 'Нет';
};

export const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';

    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
};

// Универсальная функция форматирования для UniversalEditor
export const formatValue = (value, format, suffix = '') => {
    if (value === null || value === undefined) return '—';

    switch (format) {
        case 'currency':
            // Используем formatCurrency без символа валюты, добавим ₽ сами
            return new Intl.NumberFormat('ru-RU', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(value) + ' ₽';

        case 'number':
            const formatted = new Intl.NumberFormat('ru-RU', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(value);
            return suffix ? `${formatted} ${suffix}` : formatted;

        case 'percent':
            return formatPercent(value);

        case 'boolean':
            return formatBoolean(value);

        case 'date':
            return formatDate(value);

        case 'datetime':
            return formatDateTime(value);

        default:
            return suffix ? `${value} ${suffix}` : String(value);
    }
};

// Алиас для совместимости с UniversalEditor
export const formatAmount = (amount) => {
    if (amount === null || amount === undefined) return '—';

    return new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(amount) + ' ₽';
};